export const ERROR_LOGIN_REQUIRED = 'Login required';

export const AUTH_TOKEN_REQUESTS_TIMEOUT = 20000;

export const UUID_SESSION_STORAGE_KEY = 'pg-pnc-token-uuid';
